import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Selectează locația',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Comandă la masă',
    [ORDER_METHODS.PICKUP]: 'Ridicare',
    [ORDER_METHODS.DELIVERY]: 'Livrare',
  },
  text_inputs: {
    address: {
      placeholder: 'Caută adresa ta',
    },
    street_name: {
      placeholder: 'Stradă',
    },
    street_number: {
      placeholder: 'Număr',
    },
    city: {
      placeholder: 'Oraș',
    },
    zip: {
      placeholder: 'Cod poștal',
    },
  },
  time_options: {
    asap: {
      title: 'Standard',
      description: 'Gata în {{time}} min',
    },
    scheduled: {
      title: 'Programează pentru mai târziu',
    },
  },
  time_drop_down: {
    today: 'Astăzi',
  },

  pickup: {
    address: 'Adresa de ridicare',
    when: 'Când?',
  },

  delivery: {
    where: 'Unde?',
    when: 'Când?',
    address: 'Adresa ta',
    delivery_area: 'Raza noastră de livrare',
  },

  buttons: {
    view_menu: 'Vezi meniul',
    see_hours: 'Vezi programul',
    next: 'Continuă',
    change: 'Schimbă',
    save: 'Salvează',
  },

  labels: {
    when: 'Când?',
    pickup: 'Ridicare online',
    delivery: 'Livrare',
    pickup_time: 'ora ridicării',
    delivery_time: 'ora livrării',
    discount: 'Doar aici {{value}} reducere online',
    pre_orders_enabled: 'Momentan, poți plasa o comandă programată pentru mai târziu',
    change_location: '← Revino la meniu dacă preferi o altă locație',
    return: 'Înapoi',
  },

  items_dropped: {
    count_one: '{{count}} articol eliminat',
    count_few: '{{count}} produse eliminate',
    count_other: '{{count}} articole eliminate',
    pickup_reason: '— indisponibil pentru ridicare.',
    delivery_reason: '— nu este disponibil pentru livrare.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Ne pare rău, nu am putut găsi această adresă. Încercați din nou introducând mai întâi strada în câmpul de căutare.',
    [ValidationErrors.address_not_serviceable]:
      'Adresa dvs. este în afara zonei de livrare. Doriți să schimbați adresa sau să treceți la ridicare? 😊',
    [ValidationErrors.no_drivers_available]:
      'Ne pare rău, momentan nu putem livra. Doriți să comandați pentru ridicare? 😊',
    pickup_unavailable: 'Ne pare rău că momentan nu oferim ridicare.',
    delivery_unavailable: 'Ne pare rău că momentan nu oferim livrare.',
    delivery_paused: 'Ne pare rău că momentan nu oferim livrare.',
    outside_pickup_times: 'Momentan nu oferim ridicare. Orele de ridicare:',
    outside_delivery_times: 'Momentan nu oferim livrare. Orele de livrare:',
    orders_paused_inactivity:
      'Din cauza cererii mari, nu putem accepta mai multe comenzi online acum. Comandați în restaurant sau încercați din nou în 30 de minute.',
    orders_paused_manual_end_of_day: 'Ne pare rău, suntem închiși pentru restul zilei.',
    orders_paused_manual_until_time:
      'Din cauza cererii mari, nu putem accepta mai multe comenzi online acum. Comandați în restaurant sau încercați din nou de la {{pausedUntil}}',
    company_closed: 'Din păcate, momentan nu suntem deschiși.',
    pickup_closed:
      'Acceptăm comenzi de ridicare până la {{time}} deoarece timpul de pregătire este de {{preparationTime}} minute.',
    delivery_closed:
      'Acceptăm comenzi de livrare până la {{time}} deoarece timpul de livrare este de {{preparationTime}} minute.',
    live_orders_off: 'Ne pare rău, momentan nu putem accepta mai multe comenzi online. Vă mulțumim pentru înțelegere.',
    orders_unavailable:
      '{{type}} nu este disponibil în acest moment. Următoarea {{typeTime}} posibilă este {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Ne pare rău, nu avem șoferi disponibili. Încercați mai târziu sau comandați pentru ridicare și folosiți codul promoțional <PromoCode>{{code}}</PromoCode> la checkout.',
    without_code: 'Ne pare rău, nu avem șoferi disponibili. Încercați mai târziu sau comandați pentru ridicare.',
    copied: 'Cod promoțional copiat',
  },
};
